<template>
   <div class="register">
      <div class="splashpage" v-if="step === 0">
         <img src="/img/logo.png" alt="" class="logo">
         <img src="/img/cards.png" alt="" class="cards">
         <div class="bottom-text">
            <div class="l"><div class="fa fa-chevron-right"></div></div>
            <div class="l text">
               CONTROL | CONVENIENCE | SAVINGS
            </div>
         </div>
         <img src="/img/fuel-pump.svg" alt="" class="wording r">
         <!-- <div class="wording clearfix r">
            <div class="text l">
               <div class="small">Introducing</div>
               <div class="big">RUBiS</div>
               <div class="b clearfix"><div class="medium r">CARD</div></div>
            </div>
            <div class="icon l"><i class="fa fa-gas-pump"></i></div>
         </div> -->
         <div class="btn btn-outline btn-outline-primary" @click="next()">PROCEED <i class="fa fa-chevron-circle-right"></i></div>
      </div>
      <div class="top-content clearfix" v-if="step > 1">
         <img src="/img/logo.png" alt="" class="logo">
         <div class="right-content clearfix r">
            <div class="content-box clearfix" v-if="customer === 'B2C'">
               <img src="/img/cards_skewed-individual.png" alt="" class="card-img r">
               <div class="h5 r">I AM AN INDIVIDUAL</div>
            </div>
            <div class="content-box clearfix" v-if="customer === 'B2B'">
               <img src="/img/cards_skewed-corporate.png" alt="" class="card-img r">
               <div class="h5 r">I AM A CORPORATE</div>
            </div>
            <div class="help r help-large">E: cards@rubisuganda.com | Help Line: +256707930633</div>
            <div class="help r help-small">E: cards@rubisuganda.com <br> Help Line: +256707930633</div>
         </div>
      </div>
      <div class="row justify-content-center" v-if="step > 0">
         <div class="col-12 col-md-11 col-lg-11 col-xl-10 back-grey">
            <div v-if="(step < 6 && step != 4) || (isEditing && step != 5) || step === 9" class="btn-top-previous" @click="previous()">
               <i class="fa fa-undo-alt"></i>
            </div>
            <div class="pages">
               <div class="page" v-if="step == 1">
                  <div class="page-details">
                     <!-- <div class="position">Step {{step}}/{{steps.length}}</div> -->
                     <div class="title tx-uppercase">WHAT TYPE OF CUSTOMER ARE YOU ?</div>
                     <div class="description">Select your preferred card</div>
                  </div>
                  <div class="select-container">
                     <div class="row justify-content-center">
                        <div class="col-12 col-md-6 col-lg-4">
                           <div 
                              class="select-box" 
                              :class="{'active': customer === 'B2B'}" 
                              @click="changeCustomer({val: 'B2B'})"
                           >
                              <div class="checkmark">
                                 <i class="fa fa-check"></i>
                              </div>
                              <img src="/img/cards_skewed-corporate.png" alt="" class="img">
                              <div class="txt">CORPORATE</div>
                           </div>
                           <div class="row" v-if="customer === 'B2B'">
                              <div class="col-12 col-sm-6 col-md-12 col-xl-6 clearfix rd-content">
                                 <div class="radio-border l"><div class="dot"></div></div>
                                 <div class="txt">PREPAID</div>
                              </div>
                              <popper trigger="click" :options="{placement: 'top'}">
                                 <div class="popper">
                                    <div class="title">Postpaid Cards</div>
                                    <div class="text">
                                       For postpaid cards please contact us on <br> +256707930633
                                    </div>
                                 </div>

                                 <div class="col-12 col-sm-6 col-md-12 col-xl-6 clearfix rd-content" slot="reference">
                                    <div class="radio-border l"></div>
                                    <div class="txt l">POSTPAID</div>
                                 </div>
                              </popper>
                           </div>
                        </div>
                        <div class="col-12 col-md-6 col-lg-4">
                           <div 
                              class="select-box" 
                              :class="{'active': customer === 'B2C'}" 
                              @click="changeCustomer({val: 'B2C'})"
                           >
                              <div class="checkmark">
                                 <i class="fa fa-check"></i>
                              </div>
                              <img src="/img/cards_skewed-individual.png" alt="" class="img">
                              <div class="txt">INDIVIDUAL</div>
                           </div>
                           <div class="row" v-if="customer === 'B2C'">
                              <div class="col-12 col-sm-6 col-md-12 col-xl-6 clearfix rd-content">
                                 <div class="radio-border l"><div class="dot"></div></div>
                                 <div class="txt">PREPAID</div>
                              </div>
                              <!-- <popper trigger="click" :options="{placement: 'top'}">
                                 <div class="popper">
                                    <div class="title">Postpaid Cards</div>
                                    <div class="text">
                                       For postpaid cards please contact us on <br> +254 720 000 000
                                    </div>
                                 </div>

                                 <div class="col-12 col-sm-6 col-md-12 col-xl-6 clearfix rd-content" slot="reference">
                                    <div class="radio-border l"></div>
                                    <div class="txt l">POSTPAID</div>
                                 </div>
                              </popper> -->
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
               <div class="page" v-if="step == 2">
                  <div class="page-details">
                     <div class="row">
                        <div class="col-12 col-lg-8 order-first">
                           <div class="features-card" :class="{'individual': customer === 'B2C'}">
                              <div class="row">
                                 <div class="col-12 col-md-3 col-lg-2">
                                    <div class="shape">
                                       <div class="ico ico-features"></div>
                                    </div>
                                 </div>
                                 <div class="col-12 col-md-9 col-lg-10">
                                    <div class="text-box">
                                       <div class="title">FEATURES</div>
                                       <div class="txt" v-if="customer === 'B2C'">
                                          The RUBiS card is a Chip & PIN card which transacts on a real-time settlement platform. There is a web portal where you can monitor and manage the cards in real-time. This includes checking your card balance real-time via the portal.
                                       </div>
                                       <div class="txt" v-if="customer === 'B2B'">
                                          The RUBiS card is a ‘Chip & Pin’ card which transacts on a real-time settlement platform. There is a web portal where the fleet owner can monitor and manage the cards–real time. This includes immediate top-up, transferring money between cards and blocking / unblocking cards real-time. Fleet owners can switch cards on and/or off via the portal.
                                       </div>
                                       <!-- <div class="action">Read More</div> -->
                                    </div>
                                 </div>
                              </div>
                           </div>
                           <div class="features-card" :class="{'individual': customer === 'B2C'}">
                              <div class="row">
                                 <div class="col-12 col-md-3 col-lg-2">
                                    <div class="shape">
                                       <div class="ico ico-benefits"></div>
                                    </div>
                                 </div>
                                 <div class="col-12 col-md-9 col-lg-10">
                                    <div class="text-box">
                                       <div class="title">BENEFITS</div>
                                       <div class="txt" v-if="customer === 'B2C'">
                                          RUBiS CARD is a state of the art payment system that gives you a memorable fueling and shopping experience with the largest network of service stations in uganda. It offers Convenience, Security, Control and Cashless payments.
                                       </div>
                                       <div class="txt" v-if="customer === 'B2B'">
                                          RUBiS card is a fuel payment system that makes fleet managers’ lives much easier. It makes the fueling process easier for both drivers and managers, through easy to use RUBiS card. You can set controls for fueling locations and driver spending, giving them the flexibility they desire
                                       </div>
                                       <!-- <div class="action">Read More</div> -->
                                    </div>
                                 </div>
                              </div>
                           </div>
                           
                           <div class="chev-box" :class="{'blue': customer === 'B2C'}">
                              <div class="chev">
                                 <div class="fa fa-chevron-down chevron"></div>
                                 <div class="fa fa-chevron-down chevron"></div>
                                 <div class="fa fa-chevron-down chevron"></div>
                              </div>
                           </div>
                           <div class="row">
                              <div class="col-12 col-lg-11 col-xl-10">
                                 <div class="terms-box">
                                    <div class="title">TERMS AND CONDITIONS</div>
                                    <div class="txt">
                                       Read and understand the terms and conditions before proceeding
                                    </div>
                                    <div class="custom-check small">
                                       <input
                                          id="terms"
                                          type="checkbox"
                                          class="check_input"
                                          :checked="terms"
                                          @change="handleTermsChanged"
                                       />

                                       <label class="checkbox" for="terms"></label>
                                       <label class="check-label" for="terms">I have read and agreed to the <a href="/terms.pdf" class="link" target="_blank">terms of service</a></label>
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </div>
                        <div class="col-12 col-lg-4 order-last">
                           <div class="price-card" :class="{'individual': customer === 'B2C'}">
                              <div class="row justify-content-md-center">
                                 <div class="col-12 col-lg-12 col-xl-11">
                                    <!-- <div class="top-card">
                                       <div class="txt">COST</div>
                                    </div> -->
                                    <div class="text">
                                       Works as a debit card. An upfront top up is made on your card and the amount is used on
                                       a reducing balance.
                                    </div>

                                    <div class="price-box">
                                       <div class="icon"><i class="fa fa-wallet fa-outline"></i></div>
                                       <div class="min">CARD FEE OF {{payment_options[0].currency}} {{payment_options[0].amount_per_card}} APPLIES</div>
                                       <div class="min">Minimum topup of {{payment_options[0].currency}} {{payment_options[0].deposit_per_card}}</div>
                                    </div>

                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
               <div class="page" v-if="step == 3 && customer === 'B2C'">
                  <div class="page-details">
                     <div class="title tx-uppercase rounded blue">Prepaid Card Details</div>
                     <div class="row justify-content-center">
                        <div class="col-12">
                           <div class="form-box">
                              <div class="row">
                                 <div class="col-12 col-xl-6">
                                    <Form 
                                       classBinding="row justify-content-center" 
                                       :name="Register.forms.card_details_left.name"
                                       :ref="Register.forms.card_details_left.name" 
                                       :forms="Register.forms.card_details_left.forms" 
                                       :formData="Register.forms.card_details_left.data"
                                    />
                                 </div>
                                 <div class="col-12 col-xl-6">
                                    <Form 
                                       classBinding="row justify-content-center" 
                                       :name="Register.forms.card_details_right.name"
                                       :ref="Register.forms.card_details_right.name" 
                                       :forms="Register.forms.card_details_right.forms" 
                                       :formData="Register.forms.card_details_right.data"
                                    />
                                 </div>
                                 <div class="col-12">
                                    <div class="cards-text center mt-4" v-if="!isEditing">Cards Added: <b>{{this.cards.length}}</b></div>
                                    <div class="cards-text center mt-4" v-if="isEditing">Card: <b>{{this.currentStep+1}}</b> of <b>{{this.cards.length}}</b></div>
                                    <div class="row justify-content-md-center" v-if="isEditing">
                                       <div class="col-12 col-md-8 col-lg-7 col-xl-6">
                                          <div class="btn-group" role="group" aria-label="Basic example">
                                             <button type="button" class="btn btn-primary" @click="editPrevious()" :disabled="currentStep <= 0"><i class="fa fa-chevron-left"></i></button>
                                             <button type="button" class="btn btn-primary" @click="editNext()" :disabled="currentStep >= cards.length - 1"><i class="fa fa-chevron-right"></i></button>
                                          </div>
                                          <!-- <div class="row">
                                             <div class="col-6">
                                                <div class="btn btn-secondary btn-long">Previous</div>
                                             </div>
                                             <div class="col-6">
                                                <div class="btn btn-primary btn-long">Next</div>
                                             </div>
                                          </div> -->
                                       </div>
                                    </div>
                                    <div class="btn-group"></div>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
               <div class="page" v-if="step == 3 && customer === 'B2B'">
                  <div class="page-details">
                     <div class="title tx-uppercase rounded">Prepaid Card Details</div>
                     <div class="row justify-content-center">
                        <div class="col-12">
                           <div class="form-box">
                              <div class="row">
                                 <div class="col-12 col-xl-6">
                                    <Form 
                                       classBinding="row justify-content-center" 
                                       :name="Register.forms.company_card_details_left.name"
                                       :ref="Register.forms.company_card_details_left.name" 
                                       :forms="Register.forms.company_card_details_left.forms" 
                                       :formData="Register.forms.company_card_details_left.data"
                                    />
                                 </div>
                                 <div class="col-12 col-xl-6">
                                    <Form 
                                       classBinding="row justify-content-center" 
                                       :name="Register.forms.company_card_details_right.name"
                                       :ref="Register.forms.company_card_details_right.name" 
                                       :forms="Register.forms.company_card_details_right.forms" 
                                       :formData="Register.forms.company_card_details_right.data"
                                    />
                                 </div>
                                 <div class="col-12">
                                    <div class="cards-text center mt-4" v-if="!isEditing">Cards Added: <b>{{this.cards.length}}</b></div>
                                    <div class="cards-text center mt-4" v-if="isEditing">Card: <b>{{this.currentStep+1}}</b> of <b>{{this.cards.length}}</b></div>
                                    <div class="row justify-content-md-center" v-if="isEditing">
                                       <div class="col-12 col-md-8 col-lg-7 col-xl-6">
                                          <div class="btn-group" role="group" aria-label="Basic example">
                                             <button type="button" class="btn btn-primary" @click="editPrevious()" :disabled="currentStep <= 0"><i class="fa fa-chevron-left"></i></button>
                                             <button type="button" class="btn btn-primary" @click="editNext()" :disabled="currentStep >= cards.length - 1"><i class="fa fa-chevron-right"></i></button>
                                          </div>
                                       </div>
                                    </div>
                                    <div class="btn-group"></div>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
               <div class="page" v-if="step == 4">
                  <div class="page-details">
                     <div class="title">SELECT A PICKUP LOCATION</div>

                     <div class="row justify-content-center">
                        <div class="col-12 col-lg-11 col-xl-10">
                           <div class="form-box big-padding">
                              <div class="row">
                                 <div class="col-12 col-md-6">
                                    <Form 
                                       classBinding="row justify-content-center" 
                                       :name="Register.forms.county_select.name"
                                       :ref="Register.forms.county_select.name" 
                                       :forms="Register.forms.county_select.forms" 
                                       :formData="Register.forms.county_select.data"
                                    />
                                 </div>
                                 <div class="col-12 col-md-6">
                                    <Form 
                                       classBinding="row justify-content-center" 
                                       :name="Register.forms.pickup_station.name"
                                       :ref="Register.forms.pickup_station.name" 
                                       :forms="Register.forms.pickup_station.forms" 
                                       :formData="Register.forms.pickup_station.data"
                                    />
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
               <div class="page" v-if="step == 5">
                  <div class="page-details">
                     <div class="title">VIEW SUMMARY</div>

                     <div class="row justify-content-center" v-if="cards.length > 0">
                        <div class="col-12 col-md-10 col-lg-9" v-if="customer === 'B2C'">
                           <div class="summary-box" v-for="card in cards">
                              <div class="item clearfix">
                                 <div class="key l">CARD HOLDER NAME</div>
                                 <div class="value r">{{card.name}}</div>
                              </div>
                              <div class="item clearfix">
                                 <div class="key l">ID/PASSPORT NUMBER</div>
                                 <div class="value r">{{card.idNumber}}</div>
                              </div>
                              <div class="item clearfix">
                                 <div class="key l">MOBILE NUMBER</div>
                                 <div class="value r">{{card.mobileNo.code.callingCode + card.mobileNo.mobile}}</div>
                              </div>
                              <div class="item clearfix">
                                 <div class="key l">EMAIL ADDRESS</div>
                                 <div class="value r tx-lowercase">{{card.email}}</div>
                              </div>
                              <div class="item clearfix">
                                 <div class="key l">PICKUP STATION</div>
                                 <div class="value r">{{pickupStation.name}} - {{pickupStation.county}}</div>
                              </div>
                              <div class="item clearfix">
                                 <div class="key l">PROMO CODE</div>
                                 <div class="value r">{{card.promoCode || '-'}}</div>
                              </div>
                              <div class="item clearfix">
                                 <div class="key l">CAR REGISTRATION NUMBER</div>
                                 <div class="value r">{{card.vehicleReg || '-'}}</div>
                              </div>
                              <div class="item clearfix">
                                 <div class="key l">SMS ALERTS</div>
                                 <div class="value r">{{card.sms ? 'YES' : 'NO'}}</div>
                              </div>
                              <div class="item clearfix">
                                 <div class="key l">Millage Input</div>
                                 <div class="value r">{{card.millageInput ? 'YES' : 'NO'}}</div>
                              </div>
                              <div class="item clearfix">
                                 <div class="key l">Driver Code</div>
                                 <div class="value r">{{card.driverCode ? 'YES' : 'NO'}}</div>
                              </div>
                              <div class="item responsive clearfix">
                                 <div class="key l">PRODUCT RESTRICTION</div>
                                 <div class="value r">{{card.productRestriction}}</div>
                              </div>
                              <div class="item responsive clearfix">
                                 <div class="key l">ZONE RESTRICTION</div>
                                 <div class="value r">{{card.authorizedZones}}</div>
                              </div>
                              <div class="item responsive clearfix">
                                 <div class="key l">DAYS OF USE</div>
                                 <div class="value r">{{card.daysOfUse}}</div>
                              </div>
                           </div>
                        </div>
                        <div class="col-12 col-md-10 col-lg-9" v-if="customer === 'B2B'">
                           <div class="summary-box" v-for="card in cards">
                              <div class="item clearfix">
                                 <div class="key l">COMPANY NAME</div>
                                 <div class="value r">{{card.companyName}}</div>
                              </div>
                              <div class="item clearfix">
                                 <div class="key l">COMPANY REGISTRATION NO.</div>
                                 <div class="value r">{{card.companyRegistrationNo}}</div>
                              </div>
                              <div class="item clearfix">
                                 <div class="key l">MOBILE NUMBER</div>
                                 <div class="value r">{{card.mobileNo.code.callingCode + card.mobileNo.mobile}}</div>
                              </div>
                              <div class="item clearfix">
                                 <div class="key l">EMAIL ADDRESS</div>
                                 <div class="value r tx-lowercase">{{card.email}}</div>
                              </div>
                              <div class="item clearfix">
                                 <div class="key l">PICKUP STATION</div>
                                 <div class="value r">{{pickupStation.name}} - {{pickupStation.county}}</div>
                              </div>
                              <div class="item clearfix">
                                 <div class="key l">PROMO CODE</div>
                                 <div class="value r">{{card.promoCode || '-'}}</div>
                              </div>
                              <div class="item clearfix">
                                 <div class="key l">CARD HOLDER NAME</div>
                                 <div class="value r">{{card.name}}</div>
                              </div>
                              <div class="item clearfix">
                                 <div class="key l">CAR REGISTRATION NUMBER</div>
                                 <div class="value r">{{card.vehicleReg || '-'}}</div>
                              </div>
                              <div class="item clearfix">
                                 <div class="key l">SMS ALERTS</div>
                                 <div class="value r">{{card.sms ? 'YES' : 'NO'}}</div>
                              </div>
                              <div class="item clearfix">
                                 <div class="key l">Millage Input</div>
                                 <div class="value r">{{card.millageInput ? 'YES' : 'NO'}}</div>
                              </div>
                              <div class="item clearfix">
                                 <div class="key l">Driver Code</div>
                                 <div class="value r">{{card.driverCode ? 'YES' : 'NO'}}</div>
                              </div>
                              <div class="item responsive clearfix">
                                 <div class="key l">PRODUCT RESTRICTION</div>
                                 <div class="value r">{{card.productRestriction}}</div>
                              </div>
                              <div class="item responsive clearfix">
                                 <div class="key l">ZONE RESTRICTION</div>
                                 <div class="value r">{{card.authorizedZones}}</div>
                              </div>
                              <div class="item responsive clearfix">
                                 <div class="key l">DAYS OF USE</div>
                                 <div class="value r">{{card.daysOfUse}}</div>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
               <div class="page" v-if="step == 6">
                  <div class="page-details">
                     <div class="title">ENTER PIN SENT TO YOU VIA SMS <i class="fa fa-mobile-alt"></i></div>

                     <div class="row justify-content-center">
                        <div class="col-12 col-md-11 col-lg-10 col-xl-9">
                           <div class="form-box">
                              <Form 
                                 classBinding="row justify-content-center" 
                                 :name="Register.forms.otp_verification.name"
                                 :ref="Register.forms.otp_verification.name" 
                                 :forms="Register.forms.otp_verification.forms" 
                                 :formData="Register.forms.otp_verification.data"
                              />
                              <div class="action-box">
                                 Didn't receive OTP? <span class="link" @click="resendOTP({})">Resend OTP</span>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
               <!-- <div class="page" v-if="step ==7">
                  <div class="page-details">
                     <div class="title">ENTER PIN SENT TO YOU VIA E-MAIL <i class="fa fa-envelope-open-text"></i></div>

                     <div class="row justify-content-center">
                        <div class="col-12 col-md-11 col-lg-10 col-xl-9">
                           <div class="form-box">
                              <Form 
                                 classBinding="row justify-content-center" 
                                 :name="Register.forms.otp_verification_email.name"
                                 :ref="Register.forms.otp_verification_email.name" 
                                 :forms="Register.forms.otp_verification_email.forms" 
                                 :formData="Register.forms.otp_verification_email.data"
                              />
                              <div class="action-box">
                                 Didn't receive OTP? <span class="link" @click="resendOTP({})">Resend OTP</span>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div> -->
               <div class="page" v-if="step == 8">
                  <div class="page-details">
                     <div class="title tx-uppercase">Payment Page</div>
                     <div class="subtitle">Please select your preffered payment method and top up amount</div>

                     <div class="row justify-content-center">
                        <div class="col-12 col-md-10 col-lg-9">
                           <div class="summary-box dotted" v-if="cards.length > 0">
                              <Form 
                                 classBinding="row" 
                                 :ref="Register.forms.select_payment_option.name" 
                                 :forms="Register.forms.select_payment_option.forms" 
                                 :form_data="Register.forms.select_payment_option.data"
                              />
                              <!-- <div class="mpesa-box">
                                 <span class="ico-mpesa">
                                    <span class="path1"></span>
                                    <span class="path2"></span>
                                    <span class="path3"></span>
                                    <span class="path4"></span>
                                    <span class="path5"></span>
                                    <span class="path6"></span>
                                    <span class="path7"></span>
                                    <span class="path8"></span>
                                 </span>
                              </div> -->
                              <div v-if="paymentOption">
                                 <div class="item first clearfix">
                                    <div class="sub-item clearfix">
                                       <div class="key l">CARD FEE</div>
                                       <div class="value r tx-numeric">{{paymentOption.currency}} {{paymentOption.amount_per_card}}</div>
                                    </div>
                                    <div class="sub-item clearfix">
                                       <div class="key l">Total Cards X{{cards.length}}</div>
                                    </div>
                                    <div class="sub-item clearfix">
                                       <div class="key l bold">Total Card Fee {{cards.length}}X{{paymentOption.amount_per_card}}</div>
                                       <div class="value r tx-numeric">{{paymentOption.currency}} {{utils.numberWithCommas(paymentOption.amount_per_card * cards.length)}}</div>
                                    </div>
                                 </div>
                                 <div class="item responsive clearfix" v-for="(card,index) in cards" :key="index">
                                    <div class="key l">
                                       <div class="main">TOP UP AMOUNT</div>
                                       <div class="sub-main tx-bigger">for card <b>{{card.name}}</b></div>
                                    </div>
                                    <div class="value r clearfix">
                                       <div class="box">
                                          <div class="r">
                                             <input class="grey-input tx-numeric" v-model="deposits[index]" @input="insertCommas(index)">
                                          </div>
                                          <div class="r input-text">{{paymentOption.currency}}</div>
                                       </div>
                                       <div class="minimum sub-main tx-r">Minimum top up of {{paymentOption.currency}} {{paymentOption.deposit_per_card}}</div>
                                    </div>
                                 </div>
                                 <div class="item clearfix padded">
                                    <div class="key l">TOTAL</div>
                                    <div class="value r tx-numeric">{{paymentOption.currency}} {{getSum()}}</div>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
               <div class="page" v-if="step == 9">
                  <div class="row justify-content-center">
                     <div class="col-12 col-md-10 col-lg-7">
                        <div class="summary-box dotted" v-if="paymentOption">
                           <div class="h3">Payment Instructions</div>
                           <div class="instructions" v-html="instructions"></div>
                        </div>
                     </div>
                     <div class="col-12 col-md-10 col-lg-5">
                        <div class="summary-box dotted" v-if="paymentOption">
                           <Form 
                              classBinding="row justify-content-center" 
                              :name="Register.forms.payment_receipt.name"
                              :ref="Register.forms.payment_receipt.name" 
                              :forms="Register.forms.payment_receipt.forms" 
                           />
                        </div>
                     </div>
                  </div>
               </div>
               <div class="page" v-if="step == 10">
                  <div class="row justify-content-md-center">
                     <div class="col-12 col-md-10 col-lg-8 col-xl-7">
                        <div class="message-box">
                           <div class="icon-box">
                              <div class="icon"><i class="fa fa-check"></i></div>
                           </div>
                           <div class="message-title">CARD APPLICATION SUBMITTED</div>
                           <div class="text">
                              Your card application processing will be completed once we confirm receipt of payment.
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
            <div class="controls">
               <div class="btn btn-secondary btn-next" v-if="!isEditing && step == 3 && customer === 'B2C'" @click="addCard({
                  left: $refs[Register.forms.card_details_left.name],
                  right: $refs[Register.forms.card_details_right.name]
               })">
                  ADD MORE CARDS <i class="fa fa-plus"></i> 
               </div>
               <div class="btn btn-secondary btn-next" v-if="!isEditing && step == 3 && customer === 'B2B'" @click="addCard({
                  left: $refs[Register.forms.company_card_details_left.name],
                  right: $refs[Register.forms.company_card_details_right.name]
               })">
                  ADD MORE CARDS <i class="fa fa-plus"></i> 
               </div>
               <div class="btn btn-secondary btn-next" :disabled="loading" v-if="step == 5 && !isEditing" @click="edit(3)">
                  <i class="fa fa-arrow-left"></i> EDIT
               </div>
               <button 
                  class="btn btn-primary btn-next" 
                  v-if="step < 10" @click="next()" 
                  :disabled="(customer === '') || (step == 2 && !terms) || (step == 4 && pickupStation === '') || loading == true"
               >
                  <span v-show="loading">PROCESSING</span>
                  <span v-show="!loading">PROCEED</span> 
                  <i class="fa fa-arrow-right" v-if="!loading"></i>
                  <div class="lds-ring" v-if="loading"><div></div><div></div><div></div><div></div></div>
               </button>
            </div>
            
            <div class="bottom-steps" :class="{'success': step == 10}">
               <div class="step" v-for="(s,i) in steps" :key="i" :class="{'active' : step >= s.min && step <= s.max, 'completed': step > s.max}">
                  <div class="dotted-line"></div>
                  <div class="top-dot"><div class="dot"></div></div>
                  <div class="name">{{s.name}}</div>
               </div>
            </div>
         </div>
      </div>
   </div>
</template>

<script>
import register from "./rsc/stores/register.store";
// import 'vue-popperjs/dist/css/vue-popper.css';

export default {
	beforeDestroy() {
		this.$store.unregisterModule("register");
	},
	created() {
		utils.registerModule("register", register, this.$store);
	},
	components: {
		Form: () => import("@/libs/clarks/components/form"),
		popper: () => import("vue-popperjs"),
	},
	computed: {
		...mapGetters([
			"Register",
         "step",
         "payment_options",
			"steps",
			"instructions",
			"paymentOption",
			"customer",
			"loading",
			"cards",
			"pickupStation",
			"registratioData",
         "vehicleRestriction",
         "isEditing"
		])
	},
	data () {
      return {
         utils,
         deposits: [],
         mobile: '',
         terms: false,
         showPopper: true,
         showPopper1: false,
         currentStep: 0
      }
   },
	methods: {
		...mapActions([
			"changeCustomer",
			"moveNext",
			"resendOTP",
			"restrictionChanged",
			"previousPage",
			"fetchFormData",
			"submitPaymentMethod",
			"registerIndividual",
			"registerCorporate",
			"isFormValid",
			"submitPaymentReceipt",
			"verifyOTP",
			"resendOTP",
			"addCard",
			"sendMpesaRequest",
			"resetResendTimer",
      ]),
      handleTermsChanged(){
         this.terms = event.target.checked
      },
		async clickButton(e) {
			if (e.name === "submit") {
				if (await e.ref.isValid()) {
					$notify("success", "Valid Form", "Form is valid", 20);
				}
			}
		},
		uploadFile(e) {
			console.log("Name", e);
      },
      async previous(){
         this.$store.commit('step',this.step - 1)
      },
      edit(page){
         this.$store.commit('isEditing',true)
         this.$store.commit('step',3)
         this.currentStep = 0
         this.updateForm()   
      },
      updateForm(){
         let data = this.cards[this.currentStep]

         if(this.customer === 'B2B'){
            this.$refs['company_card_details_left'].formData_ = {
               name: data.name,
               companyName: data.companyName,
               companyRegistrationNo: data.companyRegistrationNo,
               mobileNo: data.mobileNo,
               productRestriction: data.productRestriction,
               authorizedZones: data.authorizedZones,
            }
            this.$refs['company_card_details_right'].formData_ = {
               vehicleReg: data.vehicleReg,
               email: data.email,
               sms: data.sms,
               millageInput: data.millageInput,
               driverCode: data.driverCode,
               daysOfUse: data.daysOfUse,
               promoCode: data.promoCode,
            }
         }else{
            this.$refs['card_details_left'].formData_ = {
               name: data.name,
               idType: data.idType,
               idNumber: data.idNumber,
               mobileNo: data.mobileNo,
               productRestriction: data.productRestriction,
               authorizedZones: data.authorizedZones,
            }
            this.$refs['card_details_right'].formData_ = {
               vehicleReg: data.vehicleReg,
               email: data.email,
               sms: data.sms,
               millageInput: data.millageInput,
               driverCode: data.driverCode,
               daysOfUse: data.daysOfUse,
               promoCode: data.promoCode,
            }
         }

      },
      async editPrevious(){
         if(this.customer === 'B2C' &&  await this.isFormValid({ref: this.$refs['card_details_left']}) && await this.isFormValid({ref: this.$refs['card_details_right']})){
            this.cards[this.currentStep] = {...this.$refs['card_details_left'].formData_,...this.$refs['card_details_right'].formData_}
            if(this.currentStep > 0){
               this.currentStep -= 1
               this.updateForm()
            }
         }if(this.customer === 'B2B' &&  await this.isFormValid({ref: this.$refs['company_card_details_left']}) && await this.isFormValid({ref: this.$refs['company_card_details_right']})){
            this.cards[this.currentStep] = {...this.$refs['company_card_details_left'].formData_,...this.$refs['company_card_details_right'].formData_}
            if(this.currentStep > 0){
               this.currentStep -= 1
               this.updateForm()
            }
         }
      },
      async editNext(){
         if(this.customer === 'B2C' &&  await this.isFormValid({ref: this.$refs['card_details_left']}) && await this.isFormValid({ref: this.$refs['card_details_right']})){
            this.cards[this.currentStep] = {...this.$refs['card_details_left'].formData_,...this.$refs['card_details_right'].formData_}
            if(this.currentStep < this.cards.length - 1){
               this.currentStep += 1
               this.updateForm()
            }
         }if(this.customer === 'B2B' &&  await this.isFormValid({ref: this.$refs['company_card_details_left']}) && await this.isFormValid({ref: this.$refs['company_card_details_right']})){
            this.cards[this.currentStep] = {...this.$refs['company_card_details_left'].formData_,...this.$refs['company_card_details_right'].formData_}
            if(this.currentStep < this.cards.length - 1){
               this.currentStep += 1
               this.updateForm()
            }
         }
      },
      getSum(){
         let sum = 0

         for (let i = 0; i < this.deposits.length; i++) {
            const deposit = this.deposits[i];
            sum += Number(this.removeCommas(deposit)) + this.paymentOption.amount_per_card
         }
         
         return utils.numberWithCommas(sum)
      },
		async next() {
			try {
				switch (this.step) {
               case 3:
                  if(!this.isEditing){
                     if(
                        this.customer === 'B2C' && 
                        await this.isFormValid({ref: this.$refs[this.Register.forms.card_details_left.name]}) && 
                        await this.isFormValid({ref: this.$refs[this.Register.forms.card_details_right.name]})
                     ){
                        let cards = this.$store.getters.cards
                        cards.push({
                           ...this.$refs[this.Register.forms.card_details_left.name].formData_,
                           ...this.$refs[this.Register.forms.card_details_right.name].formData_
                        })
                        this.$store.commit('cards',cards)
                        this.moveNext()
                     }else if(
                        this.customer === 'B2B' && 
                        await this.isFormValid({ref: this.$refs[this.Register.forms.company_card_details_left.name]}) && 
                        await this.isFormValid({ref: this.$refs[this.Register.forms.company_card_details_right.name]})
                     ){
                        let cards = this.$store.getters.cards
                        cards.push({
                           ...this.$refs[this.Register.forms.company_card_details_left.name].formData_,
                           ...this.$refs[this.Register.forms.company_card_details_right.name].formData_
                        })
                        this.$store.commit('cards',cards)
                        this.moveNext()
                     }
                  }else{
                     // Save details on proceed
                     if(this.customer === 'B2C' &&  await this.isFormValid({ref: this.$refs['card_details_left']}) && await this.isFormValid({ref: this.$refs['card_details_right']})){
                        this.cards[this.currentStep] = {...this.$refs['card_details_left'].formData_,...this.$refs['card_details_right'].formData_}
                        this.updateForm()
                        this.$store.commit('isEditing',false)
                        this.moveNext()
                     }if(this.customer === 'B2B' &&  await this.isFormValid({ref: this.$refs['company_card_details_left']}) && await this.isFormValid({ref: this.$refs['company_card_details_right']})){
                        this.cards[this.currentStep] = {...this.$refs['company_card_details_left'].formData_,...this.$refs['company_card_details_right'].formData_}
                        this.updateForm()
                        this.$store.commit('isEditing',false)
                        this.moveNext()
                     }
                  }
                  break;
					case 5:
                  if(this.customer === 'B2C'){
                     await this.registerIndividual()
                  }else{
                     await this.registerCorporate()
                  }
                  this.moveNext();
                  break;
               case 6:
                  // this.resetResendTimer()
                  await this.verifyOTP({ref: this.$refs[this.Register.forms.otp_verification.name]})
                  for (let i = 0; i < this.cards.length; i++) {
                     const card = this.cards[i];
                     this.deposits[i] = utils.numberWithCommas(2000)
                  }
                  break;
               // case 7:
               //    await this.verifyOTP({ref: this.$refs[this.Register.forms.otp_verification_email.name]})
               //    break;
               case 8:
                  await this.submitPaymentMethod({deposits: this.deposits, amount: this.getSum()})
                  this.moveNext();
                  break;
               case 9:
                  await this.submitPaymentReceipt({ref: this.$refs[this.Register.forms.payment_receipt.name]})
                  // this.moveNext();
                  break;
					default:
                  this.moveNext();
						break;
				}

			} catch (err) {
				throw err;
			}
      },
      insertCommas(index){
         this.deposits[index] = utils.numberWithCommas(this.removeCommas(this.deposits[index]))
      },
      removeCommas(inputNum){
         inputNum = inputNum.toString()
         return inputNum.split(",").join("")
      },
	},
	async mounted() {
      utils.registerModule("register", register, this.$store);
      await this.fetchFormData()
	}
};
</script>

<style lang="scss">
$grey: #818181;

@media(min-width: $breakpoint-xxl){
   .register{
      .bottom-steps .step .name { 
         margin: 6px 0 0 -5% !important;
      }
   }
}
@media(max-width: $breakpoint-lg){
   .register{
      .features-card{
         .shape{
            background: $secondary !important;
            border-radius: 3px 0 0 3px;
            padding: 30px 0;

            .ico {
               font-size: 35px !important;
               padding:  0 !important;
            }
         }
      }
      .features-card.individual{
         .shape{
            background: $color-one !important;
         }
      }
      .order-first{
         -ms-flex-order:13 !important;
         order:13 !important;
      }
      .order-last{
         -ms-flex-order:-1 !important;
         order:-1 !important;
      }
   }
}
@media(max-width: $breakpoint-md){
   .register{
      .splashpage{
         background-position: bottom right !important;
         .cards{
            width: 450px !important;
            top: calc(50% - 100px) !important;
            left: auto !important;
            right: 20px !important;
         }
         .bottom-text{
            bottom: 10px !important;
         }
         .wording{
            margin: 50px 40px 0 0 !important;
         }
         .btn{
            right: 40px !important;
         }
      }
      .top-content {
         .logo{
            width: 60px !important;
         }
      }
      .features-card{
         border-radius: 0 0 20px 20px !important;

         .shape{
            border-radius: 3px 3px 0 0;
         }
      }
      .summary-box{
         .item.responsive{
            .value{
               margin: 10px 0 0 0;
            }
         }
      }
      .message-box{
         margin: 30px 0 0 0 !important;
      }
   }
}
@media(max-width: $breakpoint-sm){
   .register{
      .form-box{
         .col-12{
            padding: 0 0 !important;
         }
      }
      .summary-box{
         .item.responsive{
            .value{
               float: left !important;
               width: 100%;
            }
         }
      }
      .top-content {
         position: relative;
   
         .logo{
            width: 60px !important;
            position: absolute;
            top: 18px;
         }
         .card-img {
            max-width: 90px !important;
            max-height: 90px !important;
         }
         .h5{
            font-size: 16px;
         }
         .help {
            margin: 20px 15px 0 0 !important;
         }
         .help-small{
            display: block !important;
            text-align: right;
         }
         .help-large{
            display: none;
         }
      }
      .splashpage{
         .cards{
            display: none;
         }
         .wording{
            margin: 60px 70px 0 0 !important;
         }
         .btn{
            right: 40px !important;
            bottom: 200px !important;
         }
         .bottom-text{
            bottom: 150px !important;
            color: $white;
            right: 65px !important;
            left: auto !important;
         }
      }
   }
}

.register {
	background: $background-grey;
	min-height: 100vh;

   .help-small{
      display: none;
   }
   .btn-top-previous{
      position: absolute;
      right: 25px;
      top: 7px;
      font-size: 30px;
      padding: 5px;
   }
   .btn-top-previous:hover{
      color: $secondary;
      cursor: pointer;
   }
   .rd-content{
      padding: 10px 0 0 0;
      cursor: pointer;

      .radio-border{
         width: 18px;
         height: 18px;
         border-radius: 50%;
         border: solid 2px $text-color;
         padding: 3px 0;
         text-align: center;
         display: flex;
         justify-content: center;
         margin: 0 10px 0 0;
   
         .dot{
            background: $text-color;
            width: 8px;
            height: 8px;
            border-radius: 50%;
         }
      }
      .txt{
         font-weight: $weight-bold;
         margin: 0 0 0 0 !important;
         display: block;
         width: calc(100% - 30px);
      }
   }
   .cards-text{
      font-size: 12px;
      font-weight: $weight-bold;

      b{
         font-family: $font-black;
      }
   }
   .terms-box{
      text-align: left;
      margin: 50px 0 0 0;

      .title{
         font-family: $font !important;
         font-weight: $weight-bold !important;
         font-size: 14px !important;
      }
      .txt{
         font-size: 10px;
      }
   }
   .subtitle{
      font-size: 15px;
   }
   .message-box{
      text-align: center;
      background: $white;
      margin: 80px 0 0 0;
      border-radius: 10px;
      padding: 25px 0;

      .icon-box{
         display: flex;
         justify-content: center;

         .icon{
            width: 80px;
            height: 80px;
            color: $primary;
            border-radius: 50%;
            padding: 15px 0;
            background: rgba($color: $primary, $alpha: 0.2);
            font-size: 40px;
            margin: 0 0 15px 0;
         }
      }
      .message-title{
         font-size: 16px;
         color: $primary;
         margin: 0 0 2px 0;
         font-weight: $weight-bold;
      }
   }
   .message-box.red{
      .icon{
         background: rgba($color: $secondary, $alpha: 0.2);
         color: $secondary;
      }
      .message-title{
         color: $secondary;
      }
   }
	.summary-box {
		background: $white;
		padding: 30px 20px;
		border-radius: 10px;
      margin: 30px 0;

      .sub-main.tx-r{
         font-size: 9px !important;
         font-family: $font-bold;
         text-align: right !important;
      }
      .tx-bigger{
         font-size: 11px !important;
      }
		.item {
			padding: 7px 15px;
			border-bottom: solid 2px $text-grey;
			text-transform: uppercase;

			.key {
				text-align: left;
			}
			.value {
            font-family: $font-black;
            font-size: 11px;
			}
		}
		.item:first-child {
			border-top: solid 2px $text-grey;
		}
		.item:nth-child(even) {
			background: rgba(grey, 0.25);
      }
      .sub-main.minimum{
         float: left;
         width: 100% !important;
      }
		.grey-input {
         border: 0;
			border-radius: 0;
			background: rgba($color: gray, $alpha: 0.4);
			padding: 6px 15px;
         width: 100px !important;
		}
		.input-text {
         font-family: $font;
         font-weight: $weight-bold;
			margin: 7px 10px 0 0;
      }
      .mpesa-box{
         text-align: right;
         font-size: 40px;
         margin: 0 0 10px 0;
      }
	}
	.summary-box.dotted {
		.item {
			background: $white !important;
         border-bottom: dashed 1px $text-color;
         padding: 15px;

			.key {
			}
			.sub-main {
				font-size: 11px;
			}
		}
		.item.first {
			border-top: dashed 1px $text-color !important;
		}
		.item:last-child {
			border-bottom: 0;
		}
		.padded {
			padding: 20px 15px;
		}
	}
	.price-card {
		margin: 18px 0 0 0;
		padding: 10px 10px 45px 10px;
		background: $white;
		border-radius: 10px;

		.top-card {
			margin: -40px 20px 50px 20px;
			width: auto;

			.txt {
				background: $secondary;
				padding: 4px;
				font-family: $font-black;
				font-size: 15px;
				border-radius: 10px 10px 0 0;
				color: $white;
			}
		}
		.text {
			color: $grey;
			font-size: 11px;
			font-weight: $weight-bold;
			text-align: left;
		}
		.price-box {
			border-top: dashed 1px $text-grey;
			border-bottom: dashed 1px $text-grey;
			background: $background-grey;
			padding: 15px 30px;
			margin: 30px 0 5px 0;

			.icon {
				font-size: 26px;
				margin: 0 0 10px 0;

				.fa {
					-webkit-text-stroke-color: $primary;
				}
			}
			.txt {
				font-family: $font-bold;
				font-size: 13px;
				line-height: 17px;
			}
		}
		.min {
			font-size: 11px;
			color: $grey;
			font-weight: $weight-bold;
		}
   }
   .price-card.individual{
      .top-card .txt {
         background: $color-one !important;
      }
   }
	.features-card {
		border-radius: 0 20px 20px 0;
		background: $white;
		margin: 18px 0;
		font-size: 12px;

		.text-box {
			padding: 15px 20px;
			text-align: left;

			.title {
				font-size: 18px !important;
			}
			.txt {
				margin: 5px 0 15px 0;
				font-weight: $weight-bold;
            color: $grey;
            font-size: 11px;
			}
		}
		.col-12 {
			padding: 0;
		}
		.shape {
			background: url("/img/shape-red.svg") no-repeat;
			background-size: cover;
			background-position: top right;
			width: 100%;
			height: 100%;

			.ico {
				font-size: 40px;
				padding: 20% 0 0 0;
			}
		}
		.action {
			cursor: pointer;
			color: $secondary;
			font-size: 12px;
			font-weight: $weight-bold;
		}
		.action:hover {
			text-decoration: underline;
		}
   }
   .features-card.individual{
      .shape {
         background: url("/img/shape-blue.svg") no-repeat;
      }
      .action{
         color: $color-one;
      }
   }
	.splashpage {
		width: 100%;
		height: 100vh;
		background: url("/img/cover-empty.png") no-repeat;
		background-size: cover;
		background-position: right;
		position: relative;

      .cards{
         width: 550px;
         height: auto;
         position: absolute;
         top: calc(50% - 150px);
         left: calc(50% - 200px);
      }
      .logo{
         width: auto;
         height: auto;
         max-width: 100px;
         max-height: 100px;
         margin: 20px 0 0 30px;
      }
      .bottom-text{
         position: absolute;
         bottom: 30px;
         left: 30px;

         .fa{
            display: block;
            margin: 3px 10px 0 0;
            font-size: 11px;
            color: $secondary;
         }
         .text{
            font-family: $font-black;
            font-size: 14px;
         }
      }
      .wording{
			margin: 90px 80px 0 0;
         max-width: 250px;
         max-height: 250px;
         width: auto;
         height: auto;
      }
		// .wording {
		// 	margin: 90px 80px 0 0;
		// 	color: $white;

		// 	.text {
		// 		text-align: right;

		// 		.small {
		// 			font-size: 15px;
		// 			font-weight: $weight-bold;
		// 		}
		// 		.big {
		// 			font-size: 65px;
		// 			line-height: 60px;
		// 			font-family: $font-black;
		// 		}
		// 		.medium {
		// 			font-weight: $weight-bold;
		// 			font-size: 35px;
		// 			line-height: 30px;
		// 		}
		// 		.b {
		// 			.small {
		// 				margin: 5px 10px 0 0;
		// 			}
		// 		}
		// 	}
		// 	.icon {
		// 		font-size: 50px;
		// 		margin: 10px 0 0 30px;
		// 	}
		// }
		.btn {
			position: absolute;
			right: 80px;
			bottom: 80px;
			background: $white;
		}
	}
	.bottom-steps {   
		display: table;
		table-layout: fixed;
		width: 100%;
		margin: 100px 0 30px 0;

		.step {
			display: table-cell;
			text-align: center;

			.dotted-line {
				border-top: dashed 1px $text-grey;
				margin: 0 0 0 calc(50% - 20px);
				width: 100%;
			}
			.top-dot {
				border-radius: 50%;
				width: 20px;
				height: 20px;
				border: solid 1px $secondary;
				margin: -10px 0 0 calc(50% - 20px);
				background: $white;

				.dot {
					width: 12px;
					height: 12px;
					background: $secondary;
					border-radius: 50%;
					margin: 3px;
				}
			}
			.name {
				margin: 6px 0 0 -12%;
				font-weight: $weight-bold;
				text-transform: uppercase;
            font-size: 12px;
            color: $secondary;
			}
		}
		.step:last-child {
			.dotted-line {
				border-top: 0 !important;
			}
      }
      .step.active{
         .dotted-line{
            border-color: $text-color;
         }
         .top-dot{
            border-color: $text-color;

            .dot{
               background: $text-color;
            }
         }
         .name{
            color: $text-color;
         }
      }
      .step.completed{
         .dotted-line{
            border-color: $primary;
         }
         .top-dot{
            border-color: $primary;

            .dot{
               background: $primary;
            }
         }
         .name{
            color: $primary;
         }
      }
   }
   .bottom-steps.error{
      .step:last-child{
         .top-dot{
            border-color: $secondary !important;

            .dot{
               background: $secondary !important;
            }
         }
         .name{
            color: $secondary !important;
         }
      }
   }
   .bottom-steps.success{
      .step:last-child{
         .top-dot{
            border-color: $primary !important;

            .dot{
               background: $primary !important;
            }
         }
         .name{
            color: $primary !important;
         }
      }
   }
	.top-content {
		background: $white;
		padding: 20px 15px 5px 40px;

		.logo {
			width: 90px;
			height: auto;
			margin: 10px 0 0 0;
		}
		.card-img {
			max-width: 100px;
			max-height: 100px;
			width: auto;
			height: auto;
		}
		.h5 {
         margin: 20px 15px 0 0;
         font-weight: $weight-bold;
		}
		.help {
         margin: 10px 25px 0 0;
         font-weight: $weight-bold;
         color: grey;
         font-size: 12px;
		}
	}
	.form-box {
		margin: 20px 0 10px 0;

		.big-text {
			font-size: 15px;
			text-transform: uppercase;
		}
		.center-text {
			padding: 4px 0 0 0;
		}
		.center-text-first {
			padding: 40px 0 0 0;
		}
		.small-input {
			margin: 0 !important;

			label {
				display: none !important;
			}
		}
	}
	.controls {
		padding: 20px 15px;
		text-align: center;
	}
	.select-container {
		margin: 40px 10px;

		.select-box {
			border: solid 1px $text-grey;
			border-radius: 10px;
			background: transparent;
			text-align: center;
			padding: 20px 0;
			cursor: pointer;
			margin: 5px 0;

			.checkmark {
				position: absolute;
				right: 25px;
				top: 15px;
				width: 22px;
				height: 22px;
				background: rgba($color: $primary, $alpha: 0.2);
				font-size: 10px;
				padding: 5px 0;
				text-align: center;
				border-radius: 50%;
				color: $primary;
				display: none;
			}
			.img {
				max-width: 250px;
				max-height: 250px;
				height: auto;
				width: auto;
				color: $text-grey;
			}
			.txt {
				font-weight: $weight-bold;
				margin: 15px 0 0 0;
				color: $text-grey;
			}
		}
		.select-box.active {
			background: $white;
			border-color: $primary;

			.icon,
			.txt {
				color: $text-color;
			}
			.checkmark {
				display: block;
			}
		}
		.select-box:hover {
			background: $white;
			.icon,
			.txt {
				color: $text-color;
			}
		}
	}
	.page {
		.page-details {
			text-align: center;
         margin: 50px 0 20px 0;
         
         .form-box{
            background: $white;
            padding: 15px;
            border-radius: 10px;
         }
			.title {
            font-family: $font-black;
            font-size: 20px;
            
         }
         .title.rounded{
            padding: 5px 30px;
            color: $white;
            background: $secondary;
            position: absolute;
            top: 0;
            border-radius: 0 0 30px 30px !important;
         }
         .title.blue{
            background: $color-one;
         }
			.position {
				color: $text-grey;
				text-transform: uppercase;
				font-size: 12px;
				font-weight: $weight-bold;
			}
		}
	}
	.top {
		.txt {
			font-weight: $weight-bold;
		}
	}
	.bottom {
		padding: 5px 10px;
		position: absolute;
		bottom: 0;
		left: 0;
		right: 0;

		.copyright {
			font-weight: $weight-bold;
		}
	}
	.back-grey {
      padding: 60px 0 0 0;
	}
}
</style>
